export default __webpack_public_path__ + "static/media/102_desktop.477eb35d.jpg";